<template>
  <div v-if="outData" class="main" :style="{
    backgroundImage: showBgImg ? 'url(' + outData.bg_img + ')' : '',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% auto'
  }">
    <zy-header :mod="navStyle"/>
    <div v-if="$slots.default" class="zy-container">
      <slot></slot>
    </div>
    <div v-if="$slots.full" class="zy-full">
      <slot name="full"></slot>
    </div>

    <zy-footer :mod="footerStyle"/>


  </div>
</template>

<script>
import ZyHeader from './header.vue'
import ZyFooter from './footer.vue'
import {createNamespacedHelpers} from 'vuex'

const {mapGetters} = createNamespacedHelpers('base/index')
export default {
  name: "index",
  components: {
    ZyHeader,
    ZyFooter,
  },
  props: {
    showBgImg: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({baseStyle: 'getBaseStyle'}),
    outData() {
      return this.baseStyle ? JSON.parse(this.baseStyle.out_data) : undefined
    },
    navStyle() {
      return this.baseStyle ? this.baseStyle.mod_list.find(item => item.mod_name === 'selection_library_header') : undefined
    },
    footerStyle() {
      return this.baseStyle ? this.baseStyle.mod_list.find(item => item.mod_name === 'selection_library_bottom') : undefined
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
.main {
  min-height: 100vh;
  width: 100%;
  background-color: #F9F9F9;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
